var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#E3EFFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0708 22.7589C23.0708 23.5283 22.4471 24.152 21.6777 24.152C20.9083 24.152 20.2845 23.5283 20.2845 22.7589C20.2845 21.9895 20.9083 21.3658 21.6777 21.3658C22.4471 21.3658 23.0708 21.9895 23.0708 22.7589Z",
    fill: "#0084FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4085 22.7589C15.4085 23.5283 14.7848 24.152 14.0154 24.152C13.246 24.152 12.6222 23.5283 12.6222 22.7589C12.6222 21.9895 13.246 21.3658 14.0154 21.3658C14.7848 21.3658 15.4085 21.9895 15.4085 22.7589Z",
    fill: "#0084FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2124 14.4H13.0167C12.772 14.4 12.5453 14.5284 12.4194 14.7382L8.90041 19.9066C8.6677 20.2944 8.86057 20.7977 9.29286 20.9307L11.0097 21.459L11.6755 21.6638L14.4008 14.4H13.2124Z",
    fill: "#0084FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6755 21.6638L11.873 21.7246C12.0347 21.7744 12.2063 21.6986 12.3035 21.5601C12.6815 21.0214 13.3073 20.6692 14.0154 20.6692C14.838 20.6692 15.5496 21.1445 15.8905 21.8355C15.9558 21.9679 16.0849 22.0623 16.2325 22.0623H19.4606C19.6082 22.0623 19.7372 21.9679 19.8025 21.8355C20.1435 21.1445 20.8551 20.6692 21.6777 20.6692C22.5003 20.6692 23.2119 21.1445 23.5528 21.8355C23.6182 21.9679 23.7472 22.0623 23.8948 22.0623H24.2256C25.1845 22.0623 26.0203 21.4097 26.2529 20.4794L26.3384 20.1375C26.476 19.587 26.3839 19.0042 26.0831 18.5231L25.0169 16.8171C24.8896 16.6135 24.6664 16.4897 24.4262 16.4897H23.0709V15.0966C23.0709 14.7119 22.759 14.4 22.3743 14.4H13.9421L11.6755 21.6638ZM24.3776 16.9988L23.0708 16.9987V18.9278C23.0708 19.1201 23.2268 19.276 23.4191 19.276L25.5776 19.2761C25.664 18.9607 25.6062 18.6268 25.4174 18.3512L24.7483 17.1863C24.6684 17.0696 24.5284 16.9988 24.3776 16.9988Z",
    fill: "#0084FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.f11f540e1ba2ed28425dee1ad37b2f31.svg";
export { ForwardRef as ReactComponent };